import React from 'react';

import { useWidgetStore } from '../state/store';

const overlayStyle: React.CSSProperties = {
  position: 'fixed',
  inset: 0,
  background: 'rgba(0,0,0,0.6)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 9999,
};
const modalStyle: React.CSSProperties = {
  background: 'white',
  padding: 24,
  borderRadius: 8,
  maxWidth: 480,
  textAlign: 'center',
};

export function CipherCorruptModal(): React.JSX.Element | null {
  const error = useWidgetStore((s) => s.error);
  if (!error || error.code !== 'cipher_corrupt') return null;
  return (
    <div role="dialog" aria-modal="true" style={overlayStyle}>
      <div style={modalStyle}>
        <h2>Problema interno de integridad de datos</h2>
        <p>Se ha detectado un error de integridad en las credenciales del tenant. Por favor contacta al soporte.</p>
        <button onClick={() => window.location.reload()} style={{ marginTop: 16 }}>
          Recargar
        </button>
      </div>
    </div>
  );
}
